import React from 'react';
import type { SVGPropsWithClassName } from './types';
import { colors } from '@/styles';

export const Delete = ({
  size = 14,
  title = 'Delete',
  fill = colors.boulder,
  className = '',
}: SVGPropsWithClassName) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 12 14"
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d={
          'M4.41,10.85a.49.49,0,0,0,.46-.45V5.32a.46.46,0,0,0-.46-.45A.45.45,0,0,0,4,5.32V10.4A.' +
          '48.48,0,0,0,4.41,10.85Z'
        }
        fill={fill}
      />
      <path
        d={
          'M7.24,10.85a.49.49,0,0,0,.46-.45V5.32a.46.46,0,0,0-.46-.45.45.45,0,0,0-.45.45V10.4A.4' +
          '8.48,0,0,0,7.24,10.85Z'
        }
        fill={fill}
      />
      <path
        d={
          'M9.45,3.9v8.2H2.21V3.9ZM4,1.59A2.3,2.3,0,0,1,5.83.91a2.77,2.77,0,0,1,2,.68A2.44,2.44,' +
          '0,0,1,8.43,3H3.57A1.72,1.72,0,0,1,4,1.59ZM.45,3.9h.91v8.65a.49.49,0,0,0,.45.45H10a.48' +
          '.48,0,0,0,.45-.45V3.9h1.14A.48.48,0,0,0,12,3.45.49.49,0,0,0,11.55,3H9.45a3.11,3.11,0,' +
          '0,0-.79-2A4.13,4.13,0,0,0,5.89,0,3.42,3.42,0,0,0,3.28,1a3.08,3.08,0,0,0-.62,2H.45A.49' +
          '.49,0,0,0,0,3.45.48.48,0,0,0,.45,3.9Z'
        }
        fill={fill}
      />
    </svg>
  );
};
